import { Chip } from '@mui/material';
import { ChipProps } from '@mui/material/Chip/Chip';

export const ChipStyled = (props: ChipProps) => {
  return (
    <Chip
      {...props}
      sx={{
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '20px',
        background: '#BEFFEF',
      }}
    />
  );
};
